import script from "./ModalSuporteTrocaMunicipio.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalSuporteTrocaMunicipio.vue?vue&type=script&setup=true&lang=js"

import "./ModalSuporteTrocaMunicipio.vue?vue&type=style&index=0&id=63361ce4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63361ce4"]])

export default __exports__